<template>
    <div>
        <h1>Cost</h1>
        <!-- Add Cost Button -->
        <b-row>
            <b-col cols="12">
                <div class="d-flex justify-content-end">
                    <b-modal
                    id="modal-add-cost"
                    :title="modalTitle"
                    centered
                    size="lg"
                    :hide-footer="true"
                    ref="addCostModal"
                    no-close-on-backdrop
                    no-close-on-esc
                >
                    <b-form v-if="modalAction !== 'view'" @submit.prevent="handleModalSubmit">
                        <validation-observer ref="addCostForm" v-slot="{ invalid }">
                        <b-form-group label="Category" label-for="category">
                            <validation-provider name="Category" rules="required" v-slot="{ errors }">
                            <b-form-input
                                id="category"
                                v-model="selectedCost.category"
                                :readonly="modalAction === 'view'"
                                
                            />
                             <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                
                        <b-form-group label="Description" label-for="description">
                            <validation-provider name="Description" rules="required" v-slot="{ errors }">
                            <b-form-input
                                id="description"
                                v-model="selectedCost.description"
                                :readonly="modalAction === 'view'"
                                
                            />
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                
                        <b-form-group label="Amount" label-for="amount">
                            <validation-provider name="Amount" rules="required|numeric|min_value:0" v-slot="{ errors }">
                            <b-form-input
                                id="amount"
                                v-model.number="selectedCost.amount"
                                type="number"
                                :readonly="modalAction === 'view'"
                                min="0"
                               
                            />
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <b-form-group label="Budget" label-for="budget">
                            <validation-provider name="Budget" rules="numeric|min_value:0" v-slot="{ errors }">
                            <b-form-input
                                id="budget"
                                v-model.number="selectedCost.budget"
                                type="number"
                                :readonly="modalAction === 'view'"
                                min="0"
                                
                            />
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                
                        <b-form-group label="Date" label-for="date">
                            <validation-provider name="Date" rules="required" v-slot="{ errors }">
                            <b-form-datepicker
                                id="date"
                                v-model="selectedCost.date"
                                :disabled="modalAction === 'view'"
                                
                            />
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                
                        <div class="d-flex justify-content-end">
                            <b-button v-if="modalAction !== 'view'" type="submit" variant="success">
                                Save
                            </b-button>
                            <b-button variant="secondary" @click="closeModal" class="ml-2">
                                Cancel
                            </b-button>
                        </div>
                    </validation-observer>
                    </b-form>
                
                
                    <div v-else>
                        <b-card
                            class="shadow-sm"
                            header="Cost Details"
                            header-bg-variant="primary"
                            header-text-variant="white"
                        >
                            <b-row>
                                <b-col cols="6">
                                    <p><strong>Category:</strong></p>
                                    <p class="text-muted">{{ selectedCost.category }}</p>
                                </b-col>
                                <b-col cols="6">
                                    <p><strong>Description:</strong></p>
                                    <p class="text-muted">{{ selectedCost.description }}</p>
                                </b-col>
                            </b-row>
                            <hr />
                            <b-row>
                                <b-col cols="6">
                                    <p><strong>Amount:</strong></p>
                                    <p class="text-success font-weight-bold" 
                                    >{{ selectedCost.amount }}</p>
                                </b-col>
                                <b-col cols="6">
                                    <p><strong>Date:</strong></p>
                                    <p class="text-muted">{{ new Date(selectedCost.date).toLocaleDateString() }}</p>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="6">
                                    <p><strong>Budget:</strong></p>
                                    <p class="text-success font-weight-bold"
                                   >{{ selectedCost.budget }}</p>
                                </b-col>
                            </b-row>
                        </b-card>
                    </div>
                </b-modal>
                

                    <b-button variant="primary" @click="openAddModal" class="mb-4">
                        <feather-icon icon="PlusIcon" class="mr-50" />
                        Add Cost
                    </b-button>
                </div>
            </b-col>
        </b-row>

        <!-- Table for Costs -->
        <b-row>
            <b-col cols="12">
                <div v-if="!tableLoading && costs.length === 0" class="text-center">
                    <h1 class="text-muted">No Cost Added Yet</h1>
                </div>
                <b-table striped hover responsive :items="costs" :fields="fields" :busy="tableLoading" class="mb-4"
                    empty-text="No costs available. Please add a cost.">
                    <template #table-busy>
                        <div class="text-center my-4">
                            <b-spinner variant="primary" small />
                            <span class="ml-2">Loading...</span>
                        </div>
                    </template>

                    <template #cell(date)="row">
                        {{ new Date(row.item.date).toLocaleDateString() }}
                    </template>

                    <template #cell(actions)="row">
                        <b-dropdown variant="link" toggle-class="p-0" no-caret>
                            <template #button-content>
                                <feather-icon icon="MoreVerticalIcon" class="text-body" size="16" />
                            </template>
                            <b-dropdown-item @click="viewCost(row.item)">
                                <feather-icon icon="EyeIcon" class="mr-1" />View
                            </b-dropdown-item>
                            <b-dropdown-item @click="editCost(row.item)">
                                <feather-icon icon="EditIcon" class="mr-1" />Edit
                            </b-dropdown-item>
                            <b-dropdown-item @click="removeCost(row.item.projectCostId)">
                                <feather-icon icon="TrashIcon" class="mr-1" />Delete
                            </b-dropdown-item>
                        </b-dropdown>
                    </template>
                </b-table>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { extend } from "vee-validate";
import Swal from "sweetalert2";
import {
    BTable,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BForm,
    BFormDatepicker,
    BDropdown,
    BDropdownItem,
    BSpinner,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";

export default {
    components: {
        ValidationObserver,
        ValidationProvider,
        BTable,
        BRow,
        BCol,
        BFormGroup,
        BFormInput,
        BButton,
        BModal,
        BForm,
        BFormDatepicker,
        BDropdown,
        BDropdownItem,
        BSpinner,
    },
    data() {
        return {
            projectId: this.$route.params.id,
            costs: [],
            newCost: {
                projectId: this.$route.params.id,
                description: "",
                category: "",
                amount: 0,
                budget: 0,
                date: "",
            },
            modalAction: "add",
            modalTitle: "Add Cost",
            selectedCost: {},
            fields: [
                { key: "category", label: "Category" },
                { key: "description", label: "Description" },
                { key: "amount", label: "Amount" },
                { key: "budget", label: "Budget" },
                { key: "date", label: "Date" },
                { key: "actions", label: "Actions" },
            ],
            loading: false,
            tableLoading: false,
        };
    },
    computed: {
        ...mapGetters("projectCostModule", {
            projectCosts: "projectCosts",
        }),
    },
    methods: {
        ...mapActions("projectCostModule", [
            "fetchProjectCosts",
            "createProjectCost",
            "deleteProjectCost",
            "updateProjectCost",
        ]),
        openAddModal() {
            this.modalAction = "add";
            this.modalTitle = "Add Cost";
            this.selectedCost = {
                projectId: this.projectId,
                description: "",
                category: "",
                amount: 0,
                budget: 0,
                date: "",
            };
            this.$refs.addCostModal.show();
        },
        viewCost(item) {
            this.modalAction = "view";
            this.modalTitle = "View Cost Details";
            this.selectedCost = { ...item };
            this.$refs.addCostModal.show();
        },
        editCost(item) {
            this.modalAction = "edit";
            this.modalTitle = "Edit Cost";
            this.selectedCost = { ...item };
            this.$refs.addCostModal.show();
        },
        closeModal() {
            this.$refs.addCostModal.hide();
        },
        handleModalSubmit() {
            if (this.modalAction === "add") {
                this.addCost();
            } else if (this.modalAction === "edit") {
                this.updateCost();
            }
        },
        async addCost() {
            let isValid = await this.$refs.addCostForm.validate();
            if(isValid){
            this.loading = true;
            try {
                await this.createProjectCost(this.selectedCost); // API call
                Swal.fire({
                    icon: "success",
                    title: "Cost Added",
                    text: "The cost was successfully added.",
                    timer: 2000,
                    showConfirmButton: false,
                });
                this.refreshCosts();
                this.closeModal();
            } catch (error) {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Failed to add cost. Please try again.",
                });
                console.error("Error adding cost:", error);
            } finally {
                this.loading = false;
            }
        }
        },
        async updateCost() {
            this.loading = true;
            try {
                const payload = {
                    projectId: this.projectId, // Ensure this is correctly populated
                    description: this.selectedCost.description,
                    category: this.selectedCost.category,
                    amount: this.selectedCost.amount,
                    budget: this.selectedCost.budget,
                    date: this.selectedCost.date,
                    projectCostId: this.selectedCost.projectCostId, // Ensure the ID is included
                };
                console.log('payload edit', payload);
                await this.updateProjectCost(payload); // Replace with update API call
                Swal.fire({
                    icon: "success",
                    title: "Cost Updated",
                    text: "The cost was successfully updated.",
                    timer: 2000,
                    showConfirmButton: false,
                });
                this.refreshCosts();
                this.closeModal();
            } catch (error) {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Failed to update cost. Please try again.",
                });
                console.error("Error updating cost:", error);
            } finally {
                this.loading = false;
            }
        },
        async removeCost(projectCostId) {
            try {
                // Confirm deletion with the user
                const confirmation = await Swal.fire({
                    title: 'Are you sure?',
                    text: 'You won\'t be able to revert this!',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!',
                    customClass: {
                        confirmButton: 'swal-confirm-btn',
                        cancelButton: 'swal-cancel-btn',
                    },
                });


                if (confirmation.isConfirmed) {
                    // Call the Vuex action with the correct projectCostId
                    await this.deleteProjectCost(projectCostId);

                    Swal.fire('Deleted!', 'The cost has been deleted.', 'success');
                    // Refresh the costs table
                    this.refreshCosts();
                }
            } catch (error) {
                Swal.fire('Error!', 'An error occurred while deleting the cost. Please try again.', 'error');
                console.error('Error deleting cost:', error);
            }
        },
        async refreshCosts() {
            this.tableLoading = true;
            try {
                await this.fetchProjectCosts(this.projectId);
                if (this.projectCosts && this.projectCosts[0].data) {
                    this.costs = this.projectCosts[0].data.map((cost) => ({
                        id: cost.projectCostId,
                        category: cost.category,
                        description: cost.description,
                        amount: cost.amount,
                        budget: cost.budget,
                        date: cost.date,
                        projectCostId: cost.projectCostId
                    }));
                } else {
                    this.costs = [];
                }
            } catch (error) {
                console.error("Error fetching project costs:", error);
            } finally {
                this.tableLoading = false;
            }
        },
    },
    async mounted() {
        await this.refreshCosts();
    },
};
</script>

<style>
.mb-4 {
    margin-bottom: 1.5rem;
}

.swal-confirm-btn {
    margin-right: 10px;
    /* Adjust spacing as needed */
}
</style>
